import { ServiceCenter } from './service-center';
import { Planning } from './planning';
import { Mission } from './mission/mission';

export class Solution {
	readonly id: number;
	plannings: Planning[];
	unassignedMissions: Mission[];
	validate: boolean;
	year: number;
	weekNumber: number;
	serviceCenter: ServiceCenter;
	notes: string;
}
